<template>
  <button
      type="button"
      class="delete-button"
      :title="label"
      :disabled="disabled"
      @click="$emit('click')">
    <i class="fa-solid fa-trash"></i>
  </button>
</template>

<script setup>
import {defineEmits, defineProps} from 'vue';

defineProps({
  label: {
    type: String,
    default: 'Löschen'
  },
  disabled: {
    type: Boolean,
    default: false
  }
})

defineEmits(['click'])
</script>

<style scoped>
.delete-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 4px;
  color: #ffffff;
  background-color: #dc3545;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s ease;
  user-select: none;
}

.delete-button:hover:not(:disabled) {
  filter: brightness(0.9);
  transform: translateY(-1px);
}

.delete-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
</style>
